import { handleAddHeatingSchedule } from 'shared/slice/essSwitchSlice';
import { tesHandleAddHeatingSchedule } from 'shared/slice/tesSwitchSlice';
import { tgsHandleAddHeatingSchedule } from 'shared/slice/tgsSwitchSlice';

export const heatingScheduleHandler = (
  dispatch,
  state,
  scope,
  data,
  type,
  location,
  machine,
  specificLocation,
  swt,
  messageBoxHandler
) => {
  if (state === 'on') {
    const dispatchData = {
      location,
      specificLocation,
      machine,
      start: data.start,
      end: data.end,
      inputTemp: data.inputTemp,
      isF: data.isF,
      index: 0,
    };
    if (swt === 'ESS') {
      dispatch(handleAddHeatingSchedule(dispatchData));
    } else if (swt === 'TGS') {
      tgsHandleAddHeatingSchedule(dispatchData);
    } else if (swt === 'TES') {
      tesHandleAddHeatingSchedule(dispatchData);
    }
  } else {
    messageBoxHandler(state, scope, type, 'heating schedule program');
  }
};
